module.exports = __webpack_public_path__ + "media/images/footer/Union _européenne-b01450e653a5efeaf892d3e72d5827a1.png";